// @ts-nocheck

export const getRandomBoostedOddImgInfosByMatchId = <T>(matchId: number, spritesheetsData: Array<T>): T | undefined => {
  const spriteUrlsCount = spritesheetsData.length;

  if (spriteUrlsCount) {
    // we get a random sprite url index by making a modulo formule
    const spriteUrlIndex = matchId % spriteUrlsCount;

    // if we have only one spritesheet, we don't apply the random mecanism but return the uniq url directly
    // if the random index is superior than the number of images, we return the first one
    if (spriteUrlsCount === 1 || spriteUrlIndex > spriteUrlsCount - 1) {
      return spritesheetsData[0];
    }

    return spritesheetsData[spriteUrlIndex];
  }
};
